import React from 'react';
import VendorBooths from './VendorBooths';

const FoodVendorFunnel = () => {
  return <VendorBooths allowedBooths={['food-truck', 'food-booth', 'food-booth-20x10', 'food-booth-20x20']} />;
};

export default FoodVendorFunnel;
